import React from 'react'
import { Modal } from 'antd'
import { Form, Icon, Input, Button } from 'antd'
import { notification } from 'antd'
import { Types } from 'store/actions/auth'

import imgLogo from 'assets/spiffme_600px.png'
import './styles.css'

const FormItem = Form.Item

class ConfirmUser extends React.Component {
  state = {
    visible: true
  }

  onClose = () => {
    this.setState({ visible: false })
    setTimeout(() => this.props.changeRoute('/'), 300)
  }

  handleSubmit = e => {
    e.preventDefault()
    const { validateFields, getFieldValue } = this.props.form

    validateFields((err, values) => {
      if (err) {
        notification['error']({
          message: 'Code is Required',
          description: 'Please enter the code.',
          duration: 3
        })
      } else {
        const { email } = this.props.match.params
        const code = getFieldValue('code')
        this.props.confirmUser(email, code)
      }
    })
  }

  resendCode = () => {
    const { email } = this.props.match.params
    this.props.resendCode(email)
  }

  render () {
    const { global, form } = this.props
    const { getFieldDecorator } = form

    return (
      <Modal
        wrapClassName='vertical-center-modal'
        visible={this.state.visible}
        footer={null}
        onCancel={this.onClose}
      >
        <div className='confirm'>
          <img className='logo' src={imgLogo} alt='logo' />
          <p className='description'>Enter the Code you received via email.</p>

          <div className='form'>
            <Form onSubmit={this.handleSubmit}>
              <FormItem>
                {getFieldDecorator('code', {
                  rules: [
                    {
                      required: true,
                      message: 'Please input your verification code!'
                    }
                  ]
                })(
                  <Input
                    prefix={
                      <Icon
                        type='key'
                        style={{ color: 'rgba(255, 255, 255, .8)' }}
                      />
                    }
                    placeholder='Verification Code'
                  />
                )}
                {/* eslint-disable-next-line */}
                <a className='form-resend' onClick={this.resendCode}>
                  Resend Code
                </a>
              </FormItem>
              <FormItem>
                <Button
                  size='large'
                  ghost
                  htmlType='submit'
                  className='form-button'
                  loading={global.status[Types.CONFIRM_SIGN_UP] === 'request'}
                >
                  Verify
                </Button>
              </FormItem>
            </Form>
          </div>
        </div>
      </Modal>
    )
  }
}
export default Form.create()(ConfirmUser)
